import { Typography } from "@circle-react-shared/uikit/Typography";

export const ItemSummary = ({ title, children }: any) => (
  <li className="flex flex-row justify-between">
    <Typography.LabelSm>{title}</Typography.LabelSm>
    {children}
  </li>
);
